var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M.29992942 6.45129667h.84979996l3.76578056 5.07884153 3.84909431-5.07884153L14 0 5.39872954 12.0639018 9.83101996 18h-.88312544l-4.03238458-5.4023346L.8664627 18H0l4.46561581-5.9360982z"}));
}

Next.defaultProps = {"width":"14","height":"18","viewBox":"0 0 14 18"};

module.exports = Next;

Next.default = Next;
